import { useEffect, useState } from 'react';
import { Button, MenuItem, Stack, TextField } from '@mui/material';
import { LOCATION_REVIEW_FILTER_OPTIONS, normalizeLocationReviewStatus } from '../helpers/locationStatusFilters';

export function LocationStatusQuickFilter({ value, onChange, loading = false }) {
  return (
    <TextField
      select
      label="Filtrar por datos correctos"
      value={normalizeLocationReviewStatus(value) || ''}
      onChange={(event) => onChange(event.target.value)}
      disabled={loading}
      InputLabelProps={{ shrink: true }}
      SelectProps={{ displayEmpty: true }}
      sx={{ minWidth: 250, maxWidth: '100%', mb: 1 }}
    >
      <MenuItem value="">Todos los estados</MenuItem>
      {LOCATION_REVIEW_FILTER_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value} sx={{ color: option.value === 'up_to_date' ? 'success.main' : 'warning.main' }}>{option.label}</MenuItem>
      ))}
    </TextField>
  );
}

export function LocationStatusFilterInput({ item, applyValue, focusElementRef, isApplyDisabled = true, onApplyFilter = () => {} }) {
  const [value, setValue] = useState(normalizeLocationReviewStatus(item.value) || '');
  useEffect(() => { setValue(normalizeLocationReviewStatus(item.value) || ''); }, [item.value]);
  const apply = () => {
    const nextItem = { ...item, value };
    applyValue(nextItem);
    onApplyFilter(nextItem);
  };
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 300 }}>
      <TextField
        select
        fullWidth
        inputRef={focusElementRef}
        label="Datos correctos"
        variant="standard"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') { event.preventDefault(); apply(); }
        }}
      >
        <MenuItem value="">Seleccionar estado</MenuItem>
        {LOCATION_REVIEW_FILTER_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ color: option.value === 'up_to_date' ? 'success.main' : 'warning.main' }}>{option.label}</MenuItem>
        ))}
      </TextField>
      <Button
        type="button"
        variant="contained"
        size="small"
        aria-label="Aplicar filtro"
        disabled={isApplyDisabled && value === (normalizeLocationReviewStatus(item.value) || '')}
        onClick={apply}
      >Buscar</Button>
    </Stack>
  );
}
